import './Offers.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import Box from "./Box";
import BoxOpenWindow from "./BoxOpenWindow";
import TutorialComponent from "../../tutorial/TutorialComponent";
import ButtonCloseMainPopup from "../ButtonCloseMainPopup";
import React from "react";
import {isTablet} from "react-device-detect";

function OffersComponent() {

    const {openBox, isLoading} = useTypedSelector(state => state.auth);

    let classContainer = 'offerOpenBox';
    if (openBox !== false) {
        classContainer += ' offerOpenBoxActive';
    }
    let loadingClass = 'offerLoading';
    if (isLoading) {
        loadingClass += ' offerLoadingVisible';
    }

    let offersBoxLineClass = 'offersBoxLine';

    if (isTablet){
        offersBoxLineClass += ' offersBoxLineTablet';
    }

    return (
        <div className='main-popup-container'>
            <ButtonCloseMainPopup/>

            <div className={'offersTitle'}>
                <div className={'offersTitleText'}>Offers</div>
            </div>
            <div className={loadingClass}>
                <div id='l3'></div>
            </div>
            <TutorialComponent/>

            <div className={offersBoxLineClass}>

                <Box box={{id:4,price:500, type: 'Default'}}/>
                <Box box={{id:5, price:1000, type: 'Seasoned'}}/>

            </div>


            <div className={classContainer}>
                {(openBox !== false) ?
                    <BoxOpenWindow openBox={openBox}/>
                    :
                    <div></div>
                }
            </div>
        </div>
    );
}

export default OffersComponent;